import { Component, OnInit } from '@angular/core';
import { ContactType } from '../enums/contact-type.enum';
import { ContactSettingModel } from '../model/contact-setting.model';
import { ContactModel } from '../model/contact.model';
import { ContactService } from '../service/contact.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { IdentityService } from 'src/app/@core/services/identity.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  sent: boolean = false;
  isRtl: boolean = true;
  emailNotValid: boolean = false;
  emailList: ContactSettingModel[] = [];
  phoneList: ContactSettingModel[] = [];
  contactInfo: ContactSettingModel[] = [];
  model: ContactModel = {} as ContactModel;

  constructor(private service: ContactService, private errorHandler: ErrorHandlerService, private langService: LanguageService,
    private identityService: IdentityService){}

  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  ngOnInit(): void {
    scrollTo(0, 0);
    this.isRtl = this.langService.getCurrentLanguage() === LanguageEnum.ar;
    this.langService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getContactSettings();
  }
  
  getContactSettings(): void {
    this.service.GetContactSettings().subscribe((result: ContactSettingModel[]) => {
      this.contactInfo = result;
      this.emailList = this.contactInfo.filter(c => c.contactType === ContactType.Email);
      this.phoneList = this.contactInfo.filter(c => c.contactType === ContactType.Phone);
    });
  }

  getContactValue(type: ContactType, isSocialLink = false): string {
    if (this.contactInfo.length > 0) {
      let url = String(this.contactInfo.find(x => x.contactType === type)?.title);
      if(isSocialLink && url !== 'undefined') window.open(url, '_blank');
      else return url;
    }
    return '';
  }

  save(): void {
    if (!this.model.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)){
      this.emailNotValid = true;
      return;
    }
    this.emailNotValid = false;
    this.sent = false;
    this.service.create(this.model).subscribe({
      next: data => {
        this.model = {} as ContactModel;
        this.sent = true;
        setTimeout(() => {
          this.sent = false
        }, 10000);
      },
      error: (error:HttpErrorResponse) => this.errorHandler.handleError(error)
    });
  }

  checkContactTypeExist(contactType: ContactType): boolean {
    if(this.contactInfo.find(c => c.contactType === contactType))
      return true;
    return false;
  }

  get ContactInfoType() {
    return ContactType;
  }
}
